import styled, { css } from 'styled-components/macro';
import errorIcon from '../../assets/error.svg';

export const Wrapper = styled.div<{ isMobile: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: ${(props) => (props.isMobile ? '16px' : '32px')};
`;

export const TextContainer = styled.div`
  box-sizing: border-box;
  width: fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  max-width: 704px;
`;

export const LinkText = styled.a`
  text-decoration: none;
  font-size: inherit;
  line-height: inherit;
  color: ${(props) => props.theme.colors.primary[600]};
`;

export const ErrorCircle = styled.div<{ isMobile: boolean }>`
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.gray[100]};
  border-radius: 999px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.isMobile ? '128px' : '180px')};
  height: ${(props) => (props.isMobile ? '128px' : '180px')}; ;
`;

export const ErrorsIcon = styled.img.attrs({
  src: errorIcon,
})<{ isMobile: boolean }>`
  width: ${(props) => (props.isMobile ? '44px' : '68px')};
  height: ${(props) => (props.isMobile ? '44px' : '68px')};
`;

export const ButtonsWrapper = styled.div<{
  isMobile: boolean;
  isDesktop: boolean;
}>`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
  gap: ${(props) => (props.isMobile ? '8px' : '16px')};
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.isDesktop
      ? css`
          position: relative;
          max-width: 704px;
        `
      : css`
          position: absolute;
          bottom: 0;
        `}
  padding: 0 16px 16px;
`;
